import { gql } from "@apollo/client";

export const getLensScores = gql`
    fragment LensScoreMetricsFields on LensScoreMetrics {
        lensScore
        subscriberActionsUu
        subscribeCount
    }

    fragment LensScoreWindowFields on LensScoreWindow {
        windowStart
        windowEnd
        dataThrough
        finalizationStatus
        totals {
            ...LensScoreMetricsFields
        }
        eligibility
        payout {
            state
            amountMilliUsd
            paidOn
            expectedBy
        }
    }

    fragment LensScoreDailyFields on LensScoreWindow {
        dailyBuckets {
            date
            metrics {
                ...LensScoreMetricsFields
            }
        }
    }

    query lensScores(
        $input: LensScoresInput!
        $includeLensDaily: Boolean! = false
        $includeLensMetadata: Boolean! = true
    ) {
        lensScores(input: $input) {
            payoutMinimumScore
            cursor
            summary {
                submittedCount
                scoredCount
                availableScoredCount
                paidAmountMilliUsd
                availableTotals {
                    ...LensScoreMetricsFields
                }
                missingTotalsCount
            }
            creatorTotal {
                selectedMonth {
                    ...LensScoreWindowFields
                    ...LensScoreDailyFields
                }
            }
            lensResults {
                unlockableId
                lens @include(if: $includeLensMetadata) {
                    id
                    name
                    iconUrl
                    organizationId
                    lensAccountId {
                        lensSpaceId
                    }
                }
                selectedMonth {
                    ...LensScoreWindowFields
                    # Inline: codegen types a conditional fragment spread as always present.
                    dailyBuckets @include(if: $includeLensDaily) {
                        date
                        metrics {
                            ...LensScoreMetricsFields
                        }
                    }
                }
            }
        }
    }
`;
